import { Link } from 'react-router-dom';
import Icons from '../../../../../components/Common/Icons/Icons';
import Checkbox from '../../../../../components/Common/UI/Checkbox';
import { useENotificationsContext } from '../../../../context/e-notifications';
import { formatTime } from '../../../../notifications';

function EmailsList() {
  const { emails } = useENotificationsContext();

  return (
    <div>
      {emails?.map(el => (
        <Link
          to={`/guidance/notifications/${el.key}`}
          key={el.key}
          className="grid grid-cols-[auto,1fr,auto] items-center gap-[20px] px-[20px] py-[10px] text-addition11
          border-b border-[#f7f8fc]"
          onClick={e => e.stopPropagation()}
        >
          <div className="flex items-center gap-[20px]">
            <Checkbox
              id={el.key}
              variant="guidance"
              className="rounded-[3px] border-[2px] border-addition11 h-[19px] w-[19px]"
              onClick={e => e.stopPropagation()}
            />
            <Icons.Star className="cursor-pointer" />
          </div>
          <div className="flex items-center gap-[20px]">
            <div className="font-medium text-[15px] mr-[10px]">{el.author}</div>
            <div className="font-medium text-[15px]">{el.subject}</div>
            <div className="text-[15px] text-addition11-40">{`- ${el.description}`}</div>
          </div>
          <div className="font-medium text-[16px]">{formatTime(el.time)}</div>
        </Link>
      ))}
    </div>
  );
}

export default EmailsList;
